import { NODE_ENV, ENV } from '@env';
import Sentry from './sentry/Sentry';
import { isWeb } from './utils/isWeb';
import { getConnectionInfo } from './utils/get-connection-info/getConnectionInfo';

function getNetworkTags(): Record<string, string | number | boolean> {
  const tags: Record<string, string | number | boolean> = {};
  if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
    tags['network.online'] = navigator.onLine;
  }
  const conn = getConnectionInfo();
  if (conn) {
    if (typeof conn.effectiveType === 'string') tags['network.effective_type'] = conn.effectiveType;
    if (typeof conn.downlink === 'number') tags['network.downlink'] = conn.downlink;
    if (typeof conn.rtt === 'number') tags['network.rtt'] = conn.rtt;
    if (typeof conn.saveData === 'boolean') tags['network.save_data'] = conn.saveData;
  }
  return tags;
}

export function logInfo(...msg: any[]) {
  console.log(...msg);
}

export function logFocusInfo(...msg: any[]) {
  if (ENV === 'DEV') {
    console.log('%c[FOCUS INFO]', 'color: green;', ...msg);
  }
}

export function logFocusWarning(...msg: any[]) {
  if (ENV === 'DEV') {
    console.warn('%c[FOCUS WARNING]', 'color: yellow;', ...msg);
  }
}

export function logWarning(...msg: any[]) {
  console.warn(...msg);
}

export function logDebug(...msg: any[]) {
  console.debug(...msg);
}

export function logError(...msg: any[]) {
  if (NODE_ENV !== 'test') {
    if (isWeb()) {
      Sentry.captureException(new Error(msg.join(' ')), { tags: getNetworkTags() });
    }

    console.error(...msg);
    // datadog.logError(...msg); // WEB: handle automatic error tracking, MOBILE: TODO - need to test
  }
}

export function logSDKError(error: any, options: string | object) {
  logError(`[SDK]`, error, '\n', typeof options === 'string' ? options : JSON.stringify(options));
}
